import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { VisitorDetail } from "../VisitorDetail";
import { RaffleIcon } from "../../../assets/image/RaffleIcon";
import { RebootIcon } from "../../../assets/image/RebootIcon";
import { ArrowLeftIcon } from "../../../assets/image/ArrowLeftIcon";
import { CrownIcon } from "../../../assets/image/CrownIcon";
import { REFINE_OPTIONS } from "../../../utils/variables";
import { deleteVisitors, getVisitorData } from "../../../api/visitorApi";
import { ProfileVisitorMessage } from "./ProfileVisitorMessage";
import { useInterviewStore } from "../../../store/useInterviewStore";

export function ProfileVisitor() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isCheck, setIsCheck] = useState(true);
  const [visitorData, setVisitorData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [deleteList, setDeleteList] = useState([]);

  const {
    recived,
    setRecived,
    view,
    setView,
    refine,
    setRefine,
    resetInterviewState,
  } = useInterviewStore();

  useEffect(() => {
    return () => {
      resetInterviewState();
    };
  }, []);

  const slugData = useParams();
  let data = slugData.name;

  const fetchVisitorData = async () => {
    setVisitorData([]);
    try {
      const result = await getVisitorData(refine);
      setVisitorData(result.data.allvisitors);
    } catch (error) {
      console.error("Error fetching visitor data:", error);
    }
  };

  useEffect(() => {
    if (isCheck) {
      fetchVisitorData();
      setIsCheck(false);
    }

    setView(data ? data : "");
  }, [isCheck, visitorData, data, slugData]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setRecived("text-refine");
    }
  }, []);

  const handleSelectElement = () => {
    const ele = document.getElementsByName("chk");
    visitorData.map((data) => {
      deleteList.push(data.id);
    });
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = true;
    }
  };

  const handleDeselectElement = () => {
    const ele = document.getElementsByName("chk");
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = false;
    }
    setDeleteList([]);
  };

  const handleDeleteElement = (a) => {
    let sum = false;
    deleteList.map((e) => {
      if (e == a) {
        sum = true;
        const index = deleteList.indexOf(a);
        if (index > -1) {
          deleteList.splice(index, 1);
        }
      }
    });
    if (sum == false) {
      deleteList.push(a);
    }
  };

  const fetchDeleteVisitor = async () => {
    try {
      await deleteVisitors(deleteList);
      fetchVisitorData();
    } catch (error) {
      console.error("Error deleting visitors:", error);
    }
  };

  const handleRefineDay = (e) => {
    setRefine({
      threedays: e == "3" ? true : "",
      withinweek: e == "7" ? true : "",
      twofourday: e == "24" ? true : "",
      withinmonth: e == "30" ? true : "",
    });
    setIsCheck(true);
  };

  return (
    <div>
      {view == "" ? (
        <>
          <div class="main-header">
            <h2 className="border">{t("recent-profile-visitors")}</h2>
            <div class="mail-header-bar">
              <p>
                {visitorData.length} {t("profile")}
              </p>
              <div class="btn-group flex">
                {t("text-refine")}
                <div className="select">
                  <label onClick={(e) => setIsActive(!isActive)}>
                    {t(recived)}
                    <span>
                      <img src="/images/done_a.svg" />
                    </span>
                  </label>
                  {isActive && (
                    <ul>
                      {REFINE_OPTIONS.map((option) => (
                        <li
                          key={option.label}
                          onClick={() => {
                            setRecived(t(option.label));
                            handleRefineDay(option.value);
                            setIsActive(!isActive);
                          }}
                        >
                          {t(option.label)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div class="mail-option">
              <div class="chk-all">
                <input
                  type="checkbox"
                  class="mail-radio mail-group-radio"
                  name="chk"
                  id="checkbox_id"
                  onClick={(e) => {
                    if (e.target.checked) {
                      handleSelectElement();
                    } else {
                      handleDeselectElement();
                    }
                  }}
                />
                <span className="circle"></span>
                <label for="checkbox_id">{t("select-all")}</label>
              </div>
              <div class="right-side-btn">
                <div class="delete-btn" onClick={(e) => fetchDeleteVisitor()}>
                  <a href="#">
                    <RaffleIcon />
                    <span> {t("text-delete")}</span>
                  </a>
                </div>
                <div class="refresh-btn" onClick={(e) => fetchVisitorData()}>
                  <a href="#">
                    <RebootIcon />
                  </a>
                  <span>{t("text-refresh")}</span>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-inbox table-hover recentshow2">
            <tbody>
              {visitorData.map((data, index) => {
                if (index <= 116) {
                  return (
                    <ProfileVisitorMessage
                      slugData={slugData}
                      handleDeleteElement={handleDeleteElement}
                      data={data}
                    />
                  );
                }
              })}
            </tbody>
          </table>

          <div className="upgared">
            <p>
              {visitorData.length - 2 > 1 ? visitorData.length - 2 : 0}
              {t("more people visited your profile.")} <br />
              {t("Please upgrade to view their profiles and connect.")}
            </p>
            <Link to={""}>
              <CrownIcon />
              {t("upgrade-now")}
            </Link>
          </div>
        </>
      ) : (
        <div class="main-header">
          <button
            onClick={(e) => {
              navigate("/search-providers/" + slugData.id);
              setView("");
            }}
          >
            <ArrowLeftIcon />
            {t("text-back")}
          </button>
          <VisitorDetail id={view} />
        </div>
      )}
    </div>
  );
}
